import { useStore } from "../context/store"
import { isSkuBackOrderable } from "@/components/MultiFinshProductBundle/utils"
import Image from "@/components/Shared/Image"

import {
  getSelectedColorImage,
  isAvailableInventory,
} from "@/responseProcessors/productResponseProcessor"

const ProductOptionSelectorSwiperSlideUI = props => {
  const {
    swatchName = "",
    product = {},
    staticTexts = {},
    openPdpQuickViewModal = () => {},
    handleSelectItem = () => {},
    variantSku = "",
    setTriggerAnalyticsOnProductClick = () => {},
    optionCategory = "",
  } = props || {}

  const { masterSku, colorDetails, imageDetails } = product
  const { outOfStockText = "", quickViewLabel = "" } = staticTexts
  const { state } = useStore()
  const { inventory = [], inventoryStatus = false, projectionData = [] } = state

  const {
    imageUrl = "",
    sku: productSku = "",
    customerFacingSku = "",
  } = getSelectedColorImage({
    colorDetails,
    imageDetails,
    swatchName,
  })

  const isInventory = isAvailableInventory({
    inventory,
    sku: productSku,
  })

  const isBackorderable = isSkuBackOrderable({
    data: projectionData,
    sku: productSku,
  })

  const isSelected = productSku === variantSku

  const onProductClick = () => {
    handleSelectItem({
      masterSku,
      sku: productSku,
      isInventory: isInventory,
      customerFacingSku,
    })
    setTriggerAnalyticsOnProductClick({
      sku: productSku,
      optionCategory,
    })
  }

  const quickViewEnable = !inventoryStatus || isInventory || isBackorderable

  return (
    <div className="option">
      <Image
        width={150}
        height={150}
        src={imageUrl}
        alt={masterSku}
        loading="eager"
        onClick={onProductClick}
        className={`product-option-image ${isSelected ? "selected" : ""}`}
        tabIndex={0}
      />
      {quickViewEnable ? (
        <p
          className="quick-view-button"
          onClick={() => openPdpQuickViewModal(product, productSku)}
          tabIndex={0}
        >
          {quickViewLabel}
        </p>
      ) : (
        <p className="out-of-stock">{outOfStockText}</p>
      )}
    </div>
  )
}

export default ProductOptionSelectorSwiperSlideUI
